import type { FormlyFieldConfig } from '@ngx-formly/core';

export const form: FormlyFieldConfig[] = [
	{
		id: 'cardNumber',
		key: 'cardNumber',
		props: {
			label: 'storyblok.giftcard.card-number.label',
			labelExtras: {
				helperText: 'storyblok.giftcard.card-number.helper-text',
				noPadding: true,
			},
			maskOptions: {
				mask: '0000-0000-0000-0000-000',
				prefix: '',
				showMaskedType: true,
				dropSpecialCharacters: false,
			},
			pattern: /^\d{4}-\d{4}-\d{4}-\d{4}-\d{3}$/,
			required: true,
			translate: true,
			validation: {
				messages: {
					pattern: 'storyblok.giftcard.card-number.invalid',
				},
			},
		},
		type: 'text',
	},
	{
		id: 'activationCode',
		key: 'activationCode',
		className: 'mt-3 block',
		props: {
			label: 'storyblok.giftcard.activation-code.label',
			labelExtras: {
				contentWidth: '',
				inputWidth: 'w-1/2 sm:w-1/3',
				helperText: 'storyblok.giftcard.activation-code.helper-text',
				noPadding: true,
			},
			maskOptions: {
				mask: '0000000',
				prefix: '',
				showMaskedType: false,
			},
			pattern: /^\d{7}$/,
			validation: {
				messages: {
					pattern: 'storyblok.giftcard.activation-code.invalid',
				},
			},
			required: true,
			translate: true,
		},
		type: 'text',
	},
];
